const exported = {
  CORE: 'core',
  HONORS: 'honors',
};

export default exported;

export const { CORE, HONORS } = exported;
